export default __webpack_public_path__ + "static/media/boellhoff-logo.3b257b5a.svg";